import "./Button.scss";

const Button = ({ content, type, width, customClass, clickHandler, small, disabled }) => {
  return (
    <>
      <button
        className={`button source-16 ${type} ${customClass} ${small ? 'small' : ''}`}
        style={{ width: { width } }}
        onClick={clickHandler && clickHandler}
      >
        {content}
      </button>
    </>
  );
};

export default Button;
